<template>
  <div v-if="filter.type === 'single' || filter.type === 'multiple'">
    <div class="filter-title-container">
      <div class="filter-title">{{ filter.name | translate | capitalize }}</div>
      <span>Set back</span>
    </div>
    <v-select
      :options="paginated"
      :filterable="false"
      :searchable="allowTextInput"
      :placeholder="filter.name | translate | capitalize"
      :multiple="filter.type === 'multiple'"
      v-model="filter.model"
      @input="onInput()"
      @open="onOpen"
      @close="onClose"
      @search="query => (this.search = query)"
      class="filter"
    >
      <template #option="{label}">{{
        (filter.translate ? $t(`filter.${filter.key}.${label}`) : label)
          | capitalize
      }}</template>
      <template #selected-option="{label}">{{
        (filter.translate ? $t(`filter.${filter.key}.${label}`) : label)
          | capitalize
      }}</template>
      <template #no-options="{ search }">
        {{
          (search
            ? "filter.messages.no_matching_results_found"
            : "filter.messages.no_keys_found") | translate
        }}
      </template>
      <template #list-footer v-if="hasNextPage">
        <li ref="load" class="loader">
          {{ "filter.messages.loading_more" | translate }}
        </li>
      </template>
    </v-select>
  </div>
  <div v-else-if="filter.type === 'range'">
    <div class="filter-title-container">
      <div class="filter-title">{{ filter.name | translate | capitalize }}</div>
      <span>Set back</span>
    </div>
    <vue-slider
      v-model="filter.model"
      class="slider"
      :min="priceRange[0]"
      :max="priceRange[1]"
      :interval="10"
      :lazy="true"
      :enable-cross="false"
      @change="onChange"
    />
    <span class="price-range">{{ displayRange(filter.model) }}</span>
  </div>
  <div v-else></div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { PRICE_RANGE } from "../../constants";
export default {
  name: "gyra-filter",
  components: {
    VueSlider
  },
  data() {
    return {
      search: "",
      limit: 10,
      observer: new IntersectionObserver(this.infiniteScroll),
      valueSet: false,
      priceRange: PRICE_RANGE
    };
  },
  props: {
    filter: { required: true, type: Object },
    allowTextInput: { required: false, default: true }
  },
  methods: {
    onInput() {
      this.$emit("input");
      if (this.$cookies.get("accept-cookie-policy")) {
        this.$gtag.event("filterSelected", {
          value: this.filter.name.replace("filter.title.", ""),
          event_label: "product",
          event_category: "filter"
        });
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    displayRange(rangeList) {
      return `${this.$n(+rangeList[0], "EUR")} - ${this.$n(
        +rangeList[1],
        "EUR"
      )}`;
    },
    onChange() {
      if (this.$cookies.get("accept-cookie-policy")) {
        this.$gtag.event("filterSelected", {
          value: this.filter.name.replace("filter.title.", ""),
          event_label: "product",
          event_category: "filter"
        });
      }
      this.valueSet = true;
      this.$emit("input");
    },
    resetRange() {
      this.valueSet = false;
      this.filter.model = PRICE_RANGE;
      this.$emit("input");
    }
  },
  computed: {
    filtered() {
      return this.filter.options.filter(
        option => option && option.includes(this.search)
      );
    },
    paginated() {
      return this.filtered.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length;
    },
    displayPlaceholderOrRange() {
      return this.valueSet
        ? this.displayRange(this.filter.model)
        : this.$t(this.filter.name);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.filter-title-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  span {
    font-size: $font-sm;
    color: $brand-gray-medium;
  }
}

.filter-title {
  font-weight: 700;
  font-size: $font-sm;
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.vue-slider {
  margin: 0 0.5rem;
}

.vue-slider-process {
  background-color: $brand-salmon;
}

.vue-slider-dot-handle {
  border-color: transparent;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.45);
}

.v-select {
  padding: 0 1rem;
}
</style>
